<app-modal-header
  [title]="title"
  (closeModal)="closeModal()"
></app-modal-header>

<div *ngFor="let data of tableData" class="col-span-2 md:col-span-1 relative">
  <div class="bg-gray-50 flex flex-col gap-2 py-4 px-5 rounded-lg m-2">
    <div class="flex gap-2 flex-wrap">
      <span class="font-bold">{{ data.sensor_name }}</span>
      <span class="text-xs flex items-center">
        <fa-icon
          [ngClass]="{
            'text-red-600': data.status == 'inactive',
            'text-green-500': data.status != 'inactive',
            'text-[8px]': true,
            'animate-pulse': true,
            'pr-0.5': true
          }"
          [icon]="faCircle"
        ></fa-icon>
        {{ data.status }}
      </span>
    </div>

    <div class="flex flex-wrap gap-8 text-sm">
      <div class="flex items-center gap-1 text-primary-600">
        <fa-icon [icon]="faStopwatch"></fa-icon>
        {{ data.TIMESTAMP }}
        <fa-icon
          matTooltip="Most recent data Timestamp"
          class="text-xs text-secondary transition-all duration-300 hover:text-secondary-700 cursor-pointer hover:scale-125"
          [icon]="faCircleInfo"
        ></fa-icon>
      </div>
    </div>
  </div>
</div>
